import { render, staticRenderFns } from "./VaimoBreadcrumbs.vue?vue&type=template&id=7b051a7e&scoped=true&"
import script from "./VaimoBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./VaimoBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoBreadcrumbs.vue?vue&type=style&index=0&id=7b051a7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b051a7e",
  null
  
)

export default component.exports